import {Footer} from 'components/Footer';
import PreRegister from 'components/PreRegister';
import {RedirectComponent} from 'components/RedirectedPDF';
import SharedNavbar from 'components/SharedNavbar';
import ScrollToTop from 'helpers/helpers';
import {About} from 'pages/About';
import {ConfirmForgotPassword} from 'pages/ConfirmForgotPassword';
import {Contact} from 'pages/Contact';
import FAQs from 'pages/FAQs';
import {ForgotPassword} from 'pages/ForgotPassword';
import Home from 'pages/Home';
import NotFoundPage from 'pages/NotFoundPage';
import {OurDoctors} from 'pages/OurDoctors';
import {PrivacyPolicy} from 'pages/PrivacyPolicy';
import Login from 'pages/auth/Login';
import Register from 'pages/auth/Register';
import PaymentResult from 'pages/PaymentResult';
import React, {useEffect} from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from 'react-router-dom';

// Simple callback handler component for payment redirection
const PaymentCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const orderId = urlParams.get('orderId');
    const amount = urlParams.get('amount');
    const currency = urlParams.get('currency');
    const vat = urlParams.get('vat');
    const payment_id = urlParams.get('payment_id');

    if (orderId) {
      // Pass all payment parameters to success route
      const queryParams = new URLSearchParams();
      if (orderId) queryParams.set('orderId', orderId);
      if (amount) queryParams.set('amount', amount);
      if (currency) queryParams.set('currency', currency);
      if (vat) queryParams.set('vat', vat);
      if (payment_id) queryParams.set('payment_id', payment_id);

      navigate(`/payment/success?${queryParams.toString()}`, {replace: true});
    } else {
      navigate('/payment/failure', {replace: true});
    }
  }, [navigate, location]);

  return <div>Processing payment...</div>;
};

export const PublicRoutes: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <SharedNavbar />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/pre-register" element={<PreRegister />} />
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/reset-password" element={<ForgotPassword />} />
        <Route
          path="/confirm-reset-password/:token"
          element={<ConfirmForgotPassword />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/our-doctors" element={<OurDoctors />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/video-call" element={<Navigate to="/" />} />
        <Route path="/consultations" element={<Navigate to="/" />} />
        <Route path="/questions" element={<Navigate to="/" />} />
        <Route path="/profile" element={<Navigate to="/" />} />
        <Route
          path="/payment/success"
          element={<PaymentResult type="success" />}
        />
        <Route
          path="/payment/failure"
          element={<PaymentResult type="failure" />}
        />
        <Route path="/payment/callback" element={<PaymentCallback />} />
        <Route path="/payment" element={<Navigate to="/" />} />
        <Route path="/redirect" element={<RedirectComponent />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default PublicRoutes;
